import { useQuery } from 'react-query';
import { postActionCounts } from '@groove/api/gateway/v1/actions';

export default function usePostActionCounts() {
  return useQuery(['postActionTabCounts'], postActionCounts);
}
